import { createFileRoute } from "@tanstack/react-router";
import { FigmaConvertProvider } from "../-agents/figma-convert-context";
import { FigmaConvertLayout } from "../-agents/figma-convert-layout";

export const Route = createFileRoute("/agents/figma-convert")({
  component: () => (
    <FigmaConvertProvider>
      <FigmaConvertLayout />
    </FigmaConvertProvider>
  ),
});
